import { InvoiceSettingsParams } from "@jugl-web/rest-api";
import { TextInput } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { FieldErrors, UseFormRegister } from "react-hook-form";

interface StateFieldProps {
  register: UseFormRegister<InvoiceSettingsParams>;
  errors: FieldErrors<InvoiceSettingsParams>;
  value: string;
}

const MAX_LENGTH = 100;

export const StateField = ({ register, errors, value }: StateFieldProps) => {
  const { t } = useTranslations();

  return (
    <div>
      <TextInput
        placeholder={t({
          id: "common.enter",
          defaultMessage: "Enter",
        })}
        {...register("state", {
          maxLength: {
            value: MAX_LENGTH,
            message: `${value.length}/${MAX_LENGTH}`,
          },
          setValueAs: (inputValue) => inputValue.trim(),
        })}
        isInvalid={!!errors.state}
        label={t({
          id: "invoices.settings.businessInformation.state",
          defaultMessage: "State",
        })}
        errorMessage={errors.state?.message}
      />
    </div>
  );
};
